import axios from 'axios'
import notification from '@/ApiConstance/toast'

export const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
})

api.interceptors.request.use(
  config => {
    if (localStorage.aiotutoradmintoken) {
      config.headers.Authorization = `Bearer ${localStorage.aiotutoradmintoken}`
    }

    // console.log(config.headers.Authorization);
    return config
  },
  error =>
    // Do something with request errora
    Promise.reject(error),

)

api.interceptors.response.use(
  response => response,

  error => {
    console.log(error.response)
    if (typeof error.response !== 'undefined') {
      // Setup Generic Response Messages

      if (error.response.config.url !== '/tokenexdate') {
        if (error.response.status === 401) {
          notification.toast(error.response.data.message, 'error')
        }
      }

      if (error.response.status === 403) {
        notification.toast(error.response.data.message, 'error')
      }

      if (error.response.status === 404) {
        notification.toast(error.response.data.message, 'error')
      }
      if (error.response.status === 405) {
        notification.toast(error.response.data.message, 'warning')
      }
      if (error.response.status === 422) {
        notification.toast(error.response.data.message, 'error')
      }
      if (error.response.status === 500) {
        if (error.response.data.error) {
          notification.toast(error.response.data.error, 'error')
        } else {
          notification.toast(error.response.statusText, 'error')
        }
      }
    }
    return Promise.reject(error)
  },
)
